import React from "react";
import LegalDocument from "components/LegalDocument/LegalDocument";
import { getTravelTerms } from "data/legalTerms";
import { useLocale } from "i18n/locale";

const TermsOfUseForTravels = () => {
    const { locale } = useLocale();
    return <LegalDocument blocks={getTravelTerms(locale)} />;
};

export default TermsOfUseForTravels;
